import { useState, useEffect } from "react";

/**
 * A component that displays an image list box
 *
 * @param {string} props
 * @returns {JSX.Element}
 */
export function ReadBox(options) {
  const [images, setImages] = useState([]);

    /**
   * A function that manages an image download
   * @param {object} event - An event object
   * @returns {void} Open the image with a link
   */
const handleClickDownloadImage = (event) => {
    const imgUrl = event.target.src;
    window.open(imgUrl, '_blank').focus();
  }

// Set variable of state
  useEffect(() => {
    if (options && options.images) {
      setImages(options.images);
    }
  }, [options]);


  return (
    <div>
      <div className="upload__image-wrapper">
        {images.map((image, index) => (
          <div key={index} className="image-item">
            <img style={{ "cursor": "pointer" }} onClick={handleClickDownloadImage}  src={image['data_url']} alt="" width="100" height="100" />
          </div>
        ))}
      </div>

    </div>
  );
}


export default ReadBox;